import { Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'htx-badge',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './badge.component.html',
  styleUrl: './badge.component.scss'
})
export class BadgeComponent {
  text = input<string>('');
  variant = input<'primary'| 'secondary' | 'tertiary' | 'success' | 'warning' | 'danger' | 'info'>('primary');

  getVariantClass() {
    return `badge--${this.variant()}`;
  }
}
